module.exports = __webpack_public_path__ + "static/media/Big_Cloud_Down_Green.8a0ecbbf.png";